import axios from "axios";
import { baseURL } from "./app/Base/helper/Constant";

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers: { 'content-type': 'application/json' }
});
axiosInstance.interceptors.request.use(
  (config) => {
    const hrmsbearertoken = localStorage.getItem("billing_app_token");
    config.headers.Authorization = hrmsbearertoken
      ? `JWT ${hrmsbearertoken}`
      : "";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => Promise.resolve(response),
  async (error) => {
    if (!error.response) {
      return Promise.reject(error);
    } else if (error.response.status === 401) {
      return new Promise(function (resolve, reject) {
        const newConfig = error.config;
        const hrmsbearertoken = localStorage.getItem("billing_app_token");
        newConfig.headers.Authorization = hrmsbearertoken
          ? `JWT ${hrmsbearertoken}`
          : "";
      });
    } else {
      return Promise.reject(error?.response?.data);
    }
  }
);

export default axiosInstance;
